<script>
export default {
    props: {
        value: {
            required: false
        }
    },
    methods: {
        submit() {
            this.$validator.validate().then(valid => {
                if (!valid) {
                    return;
                }
                this.submitForm();
            });
        },
        reValidate(formInput, modelField) {
            this.$validator.validate(formInput, modelField);
        }
    },
    computed: {
        disableSubmit() {
            return this.submitted || Object.keys(this.fields).some(key => this.fields[key].validated && this.fields[key].invalid);
        }
    },
    watch: {
        'value.id'(val) {
            this.$validator.reset();
        },
        id(val) {
            this.$validator.reset();
        }
    }
};
</script>
